import { WizardConfig, WizardErrors } from '../../types/wizard'

interface Props {
  config: WizardConfig
  updateConfig: (updates: Partial<WizardConfig>) => void
  errors: WizardErrors
}

export default function Step1AgentInfo({ config, updateConfig, errors }: Props) {
  return (
    <div>
      <h2 className="text-3xl font-bold text-gray-900 mb-2">Tell Us About Yourself</h2>
      <p className="text-gray-600 mb-8">
        This information will be used to personalize your chatbot and send you lead notifications.
      </p>

      <div className="space-y-6">
        <div>
          <label className="block text-sm font-semibold text-gray-700 mb-2">
            Your Name *
          </label>
          <input
            type="text"
            value={config.agentName}
            onChange={(e) => updateConfig({ agentName: e.target.value })}
            placeholder="John Doe"
            className={`w-full px-4 py-3 border rounded-lg focus:ring-2 focus:ring-primary-500 focus:border-transparent ${
              errors.agentName ? 'border-red-500' : 'border-gray-300'
            }`}
          />
          {errors.agentName && (
            <p className="mt-1 text-sm text-red-600">{errors.agentName}</p>
          )}
        </div>

        <div>
          <label className="block text-sm font-semibold text-gray-700 mb-2">
            Email Address *
          </label>
          <input
            type="email"
            value={config.email}
            onChange={(e) => updateConfig({ email: e.target.value })}
            placeholder="john@example.com"
            className={`w-full px-4 py-3 border rounded-lg focus:ring-2 focus:ring-primary-500 focus:border-transparent ${
              errors.email ? 'border-red-500' : 'border-gray-300'
            }`}
          />
          {errors.email && (
            <p className="mt-1 text-sm text-red-600">{errors.email}</p>
          )}
          <p className="mt-1 text-sm text-gray-500">
            We'll send lead notifications to this email
          </p>
        </div>

        <div>
          <label className="block text-sm font-semibold text-gray-700 mb-2">
            Phone Number *
          </label>
          <input
            type="tel"
            value={config.phone}
            onChange={(e) => updateConfig({ phone: e.target.value })}
            placeholder="(555) 123-4567"
            className={`w-full px-4 py-3 border rounded-lg focus:ring-2 focus:ring-primary-500 focus:border-transparent ${
              errors.phone ? 'border-red-500' : 'border-gray-300'
            }`}
          />
          {errors.phone && (
            <p className="mt-1 text-sm text-red-600">{errors.phone}</p>
          )}
        </div>
      </div>
    </div>
  )
}
